import { Banner } from '@aloft/toolkit-sui';

import { Entry } from 'contentful';

import { GlobalAlertBannerSkeleton } from './types.ts';
import { useGlobalAlerts } from './useGlobalAlerts.ts';

const ContentfulAlertBanner = ({
  alert,
}: {
  alert: Entry<GlobalAlertBannerSkeleton, undefined, string>;
}) => {
  const { title, description, type } = alert.fields;
  const status = type === 'Error' ? 'error' : 'warning';

  return <Banner title={title} description={description} status={status} canDismiss={false} />;
};

export const GlobalContentfulAlerts = () => {
  const { alerts, isLoading, isError } = useGlobalAlerts();

  if (isLoading || isError || !alerts || !alerts.length) return null;
  return alerts.map((alert) => <ContentfulAlertBanner key={alert.sys.id} alert={alert} />);
};
